<template>
  <router-link
    class="repeat-badge"
    :to="link"
    :title="label"
    :aria-label="label"
  >
    <UserAvatar
      class="repeat-badge-avatar"
      :user-id="user.id"
      compact
    />
    <span class="repeat-badge-icon">
      <FAIcon icon="retweet" />
    </span>
  </router-link>
</template>

<script>
import UserAvatar from 'src/components/user_avatar/user_avatar.vue'

import {
  displayName,
  profileLink,
} from 'src/services/user_display/user_display.js'

// Who repeated a post: their small avatar and a green repeat mark on the
// top-left corner of the author's avatar, where people look for repeats.
// Replaces the separate "X repeated" line.
export default {
  components: { UserAvatar },
  props: {
    user: { type: Object, required: true },
  },
  computed: {
    link() {
      return profileLink(this.user)
    },
    label() {
      return this.$t('status.repeated_by', { user: displayName(this.user) })
    },
  },
}
</script>

<style lang="scss">
.repeat-badge {
  position: absolute;
  top: -0.35em;
  left: -0.35em;
  z-index: 1;
  display: block;
  line-height: 0;

  .repeat-badge-avatar {
    width: 1.75em;
    height: 1.75em;
    border-radius: var(--r-item);
    box-shadow: 0 0 0 2px var(--background);
  }

  .repeat-badge-icon {
    position: absolute;
    left: 1.35em;
    top: -0.3em;
    display: grid;
    place-items: center;
    width: 1.2em;
    height: 1.2em;
    border-radius: 50%;
    line-height: 1;
    background-color: var(--background);

    /* the app's icon rule colors the svg itself */
    svg {
      color: var(--cGreen);
      width: 0.85em;
      height: 0.85em;
    }
  }
}
</style>
